import { QuantityBreakDTO } from '@/api/dto/QuantityBreakDTO';
import { CrudEndpoint } from '@/api/common/CrudEndpoint';

export class QuantityBreakCRUD extends CrudEndpoint<QuantityBreakDTO> {
  constructor() {
    super('quantitybreak');
  }
}
